<template>

  <div class="cf cf-proposal">
    <div class="cf-page cf-proposal__page">

      <!-- naglowek (uklad jak MCProposalView w _MiniCredit: jedna karta na srodku) -->
      <div class="cf-stack cf-proposal__head">
        <span class="cf-eyebrow">Decyzja</span>
        <h1 class="cf-h1">Dziękujemy za cierpliwość — mamy dla Ciebie propozycję</h1>
        <p class="cf-lead">Na podstawie analizy Twojego wniosku możemy zaproponować Ci kwotę
          <strong>{{ formatedAmount }}</strong>. Jeśli chcesz, obniż kwotę suwakiem — warunki przeliczą się automatycznie.</p>
      </div>


      <!-- ================= KARTA PROPOZYCJI ================= -->
      <section class="nau-offer">

        <div class="nau-offer__head">
          <span class="nau-offer__label">Proponowana kwota</span>
          <span class="nau-offer__badge">kontroferta</span>
        </div>

        <div class="nau-offer__amount">{{ formatedAmount }}</div>

        <div class="nau-offer__slider">
          <input class="cf-range" type="range" :min="minAmount" :max="maxAmount" :step="step" :value="loanAmount"
                 aria-label="Kwota pożyczki" @input="onInput(parseInt($event.target.value))">
          <div class="cf-range__scale"><span v-for="v in labelValues" :key="v">{{ formatCurrency(v) }} zł</span></div>
        </div>

        <ul class="nau-offer__details">
          <li><span>Miesięczna rata</span> <strong>{{ formatCurrency(installmentAmount, false) }} zł</strong></li>
          <li><span>Okres</span> <strong>{{ loanTenor }} {{ tenorSign == 'd' ? 'dni' : 'mies.' }}</strong></li>
          <li><span>Data spłaty</span> <strong>{{ finishDate }}</strong></li>
          <li><span>Prowizja</span> <strong>{{ formatCurrency(service, false) }} zł</strong></li>
          <li><span>Oprocentowanie</span> <strong>{{ formatCurrency(interest, false) }} zł</strong></li>
          <li><span>RRSO</span> <strong>{{ String(rrso).replace('.', ',') }} %</strong></li>
          <li class="nau-offer__total"><span>Razem do spłaty</span> <strong>{{ formatCurrency(total, false) }} zł</strong></li>
        </ul>

        <div class="nau-offer__link">
          <a href="#" @click.prevent="openModal">Formularz informacyjny</a>
        </div>

      </section>


      <!-- ================= DECYZJA ================= -->
      <div class="cf-proposal__actions">
        <a key="btn-prev" class="cf-btn cf-btn--quiet" @click="resign">Rezygnuję</a>
        <a key="btn-next" class="cf-btn cf-btn--primary" @click="accept">Zgadzam się</a>
      </div>

      <p class="cf-meta cf-proposal__hint">Po akceptacji wybierzesz rachunek do wypłaty i przejdziesz do podpisania umowy.
        Środki wyślemy przelewem po podpisaniu umowy.</p>

    </div>


    <!-- Modal -->
    <div  class="modal fade" ref="modal" >
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header container dark-bg">
            <div class="col-auto me-auto ">
              <h3>Formularz informacyjny</h3>
            </div>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" v-dynamic="details">

            </div>


            <div class="modal-footer justify-content-center">

              <button type="button" class="cf-btn cf-btn--primary" data-bs-dismiss="modal"> Zamknij </button>
            </div>

          </div>
      </div>
    </div>

  </div>

</template>

<script>

    import { bus } from './main';     


    export default {
     
       name: 'NauProposalView',



       data(){

            return {

              modal: null,

              details: '',

              // Slider configuration
              minAmount: 1000,
              maxAmount: 1000,
              step: 100,
              labelValues: [1000, 1000],
              sliderLabels: [],

              waitCount: 0
              
            }
       },


       computed: {


        formatedAmount(){

          return this.formatCurrency(this.loanAmount) + ' zł';
        },


        installmentAmount(){

            return (this.total / this.loanTenor).toFixed(2);
        }
         


       },


       methods: {


        onInput(v){

          // Przelicz wartości przy zmianie suwaka
          this.setValues(v, this.loanTenor, this.tenorSign);

        },


        initSlider(){

          // Inicjalizacja slidera z maksymalną wartością z propozycji
          this.maxAmount = this.loanAmount;
          this.labelValues = [this.minAmount, this.loanAmount];

          // Generowanie etykiet dla slidera
          this.sliderLabels = this.labelValues.reduce((accu, itm) => {

            if (!accu){
              return [itm];
            }

            return accu.concat( ...Array( (Math.abs(accu[accu.length-1] - itm) / this.step) - 1 ) ).concat( itm );
          }, 0);

        },


        accept(){


            var page = this.$root.mainpage;


            page.isLoading = 'to może potrwać do 2 minut..,prosimy o cierpliwość..,przygotowujemy dokumenty..';
            this.waitCount = 0;



           // this.post( '/score')
            this.post( '/counteroffer', {amount: this.loanAmount})
              .then(response => {

                if (!!response.data) {
                  let ok = !(response.data.IS_ERROR | 0);


                  this.onWaiting();              

                }           
              })
              .catch(error => {
             
                  // Error 
                  if (error.response) {           
                     console.log(error.response);
                  }                                  
              });





        },

        resign(){



            this.post( '/resign' )
              .then(response => {

                if (!!response.data) {
                  let ok = !(response.data.IS_ERROR | 0);


                    this.$router.push({path: 'resign'});
                }           
              })
              .catch(error => {
             
                  // Error 
                  if (error.response) {           
                     console.log(error.response);
                  }                                  
              });



        },



        gotomain(){

            this.$router.push({path: '/'});
        },




        onWaiting( endpoint='application' ) {


          var page = this.$root.mainpage,
              step,


            poll = () => {

              if (this.waitCount > 60){

                page.isLoading =false;
                return;
              }

              this.waitCount++;


              this.get( '/' + endpoint )
                  .then(response => {
                   

                    if (!!response.data) {

                      step = response.data.hasOwnProperty('step') ? response.data.step : '';

    //console.log(step);

                      switch (step) {

                        case 'counteroffer':
                        case 'wait':
                          break;

                        case 'account':
                          page.isLoading =false;
                          this.$router.push({path: 'account'});
                          return;

                        case 'reject':
                          page.isLoading =false;
                          this.$router.push({path: 'rej'});
                          return;

                        default:
                          page.isLoading =false;
                          this.$router.push({path: 'thankyou'});
                          return;
                      }


    //console.log(response.data)

                   
                    }
                    else {
                      console.log('status empty body');
                    }


                    // dispatch another poll request
                    page.isLoading
                      && setTimeout(poll, 3000);                



                  })
                  .catch(error => {
                   
                      // wait for timeout
                      //page.isLoading = false;
                      setTimeout(poll, 3000);

         
                      // Error 
                      if (error.response) {
                     

                      } else if (error.request) {
                        
                      } else {
                          // Something happened in setting up the request and triggered an Error
                          //console.log('Error', error.message);
                      }
                  });


            };


            // initial polling
            setTimeout(poll, 3000);
        },




        openModal(v){

          this.details = this.getModalContent('info_form');

          this.modal.show();

        }




       },


       created() {

          // Inicjalizacja slidera
          this.initSlider();

       },


    mounted(){


      // check if ais was completed
      if (!this.$root.mainpage.aisdone) {

        this.$router.push({path: '/client'})
      }
      else {

        this.$root.mainpage.aisdone = false;
      }



      this.modal = new bootstrap.Modal(this.$refs['modal']);


      // scroll to top
      this.pageTop();

    }



        
    }
</script>

<style scoped>

/* Kontroferta: jedna karta na srodku (wzor: variant-card z _MiniCredit
   MCProposalView), kolory NAU z tokenow cf-theme.css */

.cf-proposal__page {
  max-width: 900px;
  padding: 44px 32px 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
}

.cf-proposal__head {
  gap: 10px;
  align-items: center;
  text-align: center;
}

.cf-proposal__head .cf-lead {
  margin: 0 auto;
}

.nau-offer {
  width: 100%;
  max-width: 460px;
  background: #fff;
  border: 2px solid var(--cf-orange);
  border-radius: 16px;
  box-shadow: 0 16px 36px rgba(0, 118, 102, .18);
  padding: 28px 28px 22px;
  display: flex;
  flex-direction: column;
}

.nau-offer__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.nau-offer__label {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: var(--cf-ink-2);
}

.nau-offer__badge {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: var(--cf-orange-ink);
  background: var(--cf-orange-tint);
  border-radius: 999px;
  padding: 4px 11px;
}

.nau-offer__amount {
  font-size: 42px;
  font-weight: 700;
  letter-spacing: -1px;
  text-align: center;
  color: var(--cf-orange-hover);
  margin: 4px 0 6px;
}

.nau-offer__slider {
  margin-bottom: 18px;
}

.nau-offer__details {
  list-style: none;
  padding: 0;
  margin: 0 0 18px;
}

.nau-offer__details li {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 0;
  border-bottom: 1px solid var(--cf-line-soft);
  font-size: 14.5px;
  color: var(--cf-ink-2);
}

.nau-offer__details li strong {
  color: var(--cf-ink);
  text-align: right;
}

.nau-offer__details li.nau-offer__total {
  border-bottom: 0;
  margin-top: 6px;
  padding-top: 13px;
  border-top: 2px solid var(--cf-line);
  font-size: 16px;
  color: var(--cf-ink);
  font-weight: 600;
}

.nau-offer__details li.nau-offer__total strong {
  color: var(--cf-orange-hover);
}

.nau-offer__link {
  text-align: center;
  font-size: 13.5px;
}

.cf-proposal__actions {
  display: flex;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.cf-proposal__actions .cf-btn {
  min-width: 200px;
}

.cf-proposal__hint {
  margin: 0;
  text-align: center;
  max-width: 520px;
}

.modal-dialog {
  max-width: 900px;
}

.modal-body {
  overflow-y: auto;
}

@media (max-width: 600px) {

  .cf-proposal__page {
    padding: 24px 16px 48px;
    gap: 22px;
  }

  .nau-offer {
    padding: 22px 18px 18px;
  }

  .nau-offer__amount {
    font-size: 34px;
  }

  .cf-proposal__actions .cf-btn {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/NauProposalView.vue